import { render, staticRenderFns } from "./PlayerStatistics.vue?vue&type=template&id=4ce2e737&scoped=true&"
import script from "./PlayerStatistics.vue?vue&type=script&lang=js&"
export * from "./PlayerStatistics.vue?vue&type=script&lang=js&"
import style0 from "./PlayerStatistics.vue?vue&type=style&index=0&id=4ce2e737&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce2e737",
  null
  
)

export default component.exports